import React from 'react';
import { Text } from '@chakra-ui/core';
import { Td, Tr } from '@chakra-ui/table';
import { Row } from 'react-table';
import { FollowStateEnum, Position, Recruiter } from '../types';
import { FollowWatchSelector } from './FollowWatchSelector';
import colors from '../../../../../styles/colors';

export interface RecruiterTableRowProps {
  row: Row<Recruiter>;
  position: Position;
  isSelected: boolean;
}

const RecruiterTableRowComponent: React.FC<RecruiterTableRowProps> = ({ row, position, isSelected = false }) => {
  const getInitialState = React.useCallback(() => {
    const isFollowed = !!position?.assignedRecruiters?.find((a) => a.id === row.original.id);
    if (isFollowed) {
      return FollowStateEnum.Followed;
    }
    const isWatching = !!position?.watchedRecruiters?.find((a) => a.id === row.original.id);
    if (isWatching) {
      return FollowStateEnum.Watched;
    }
    return FollowStateEnum.None;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position, row]);

  const handleChange = React.useCallback(
    /* istanbul ignore next */ () => {
      /* Handle change */
    },
    [],
  );

  const tableColor = colors.table;

  return (
    <Tr
      {...row.getRowProps()}
      border={isSelected ? /* istanbul ignore next */ `1px solid ${tableColor.selectedBorder}` : '1px solid transparent'}
      sx={{
        '&:not(:last-of-type)': {
          outline: `1px solid ${isSelected ? /* istanbul ignore next */ tableColor.selectedBorder : '#e5e5e4'}`,
        },
        '&:first-child': { borderTopLeftRadius: 'lg' },
      }}
      bg={isSelected ? /* istanbul ignore next */ tableColor.selectedBg : 'transparent'}
    >
      {row.cells.map((cell) => {
        switch (cell.column.id) {
          case 'recruiterName':
            return (
              <Td {...cell.getCellProps()} isNumeric={cell.column.isNumeric as boolean} p={2}>
                <Text fontSize="sm">{`${cell.row.original.firstName} ${cell.row.original.lastName}`}</Text>
              </Td>
            );
          case 'action':
            return (
              <Td {...cell.getCellProps()} isNumeric={cell.column.isNumeric as boolean} p={2} textAlign="right">
                <FollowWatchSelector
                  initialState={getInitialState()}
                  recruiterId={row.original.id}
                  positionId={position?.id || ''}
                  onChange={handleChange}
                />
              </Td>
            );
          /* istanbul ignore next */
          default:
            /* istanbul ignore next */
            return (
              <Td {...cell.getCellProps()} isNumeric={cell.column.isNumeric as boolean} p={2}>
                {cell.render('Cell')}
              </Td>
            );
        }
      })}
    </Tr>
  );
};

export const RecruiterTableRow = React.memo(RecruiterTableRowComponent);
